import { Module, ModuleVariantsType } from '../../types'

export const createGroupCardProjectMobileConfiguration = (): Module[] => {
  return [
    { __typename: 'ModuleImages' },
    {
      __typename: 'ModuleVariants',
      type: ModuleVariantsType.RADIO,
    },
    { __typename: 'ModuleDispatch' },
    { __typename: 'ModuleMoreInfo' },
    { __typename: 'ModulePeopleAlsoViewed' },
    { __typename: 'ModuleButtons' },
  ]
}
